import React, { Fragment } from "react"
import { Link } from "gatsby"
import tw, { styled } from "twin.macro"

const JobTeaser = ({ title, body, link, terms, reference }) => (
  <Style className="article">
    <Link to={`/${link}`}>
      <h3>{title}</h3>
      <p dangerouslySetInnerHTML={{ __html: body }} />
      {terms && (
        <dl>
          {terms.map((term) => (
            <Fragment key={term.fieldName}>
              <dt>{term.fieldName}:</dt>
              <dd>{term.value}</dd>
            </Fragment>
          ))}
        </dl>
      )}
    </Link>
  </Style>
)
export default JobTeaser

const Style = styled.article`
  ${tw`antialiased`}

  > a {
    ${tw`text-gray-800 no-underline block outline-none`}

    &:focus-visible h3 {
      ${tw`text-orange`}
    }

    @media (hover: hover) {
      &:active h3,
      &:hover h3 {
        ${tw`text-primary`}
      }

      &:hover p {
        ${tw`text-default`}
      }
    }
  }

  h3 {
    ${tw`font-semibold text-xl mb-2`}
  }

  .btn > a {
    ${tw`text-gray-800`}
  }

  dl {
    ${tw`flex flex-wrap gap-1 text-xs text-gray-400 mt-3`}

    dt + dd {
      ${tw`mr-3 mb-0`}
    }

    dt {
      ${tw`font-light`}
    }

    dd {
      ${tw`font-semibold mb-0`}
    }
  }
`

export const JobIframe = styled.div`
  ${tw`border border-silver [borderWidth:3px]`}

  iframe {
    min-height: 50vh;
    height: 100%;
  }

  * + & {
    margin-top: 2em;
  }
`
